import { transform } from "ol/proj";
import type Projection from "ol/proj/Projection";

const baseUrl = "https://api3.geo.admin.ch/rest/services/all/MapServer/identify";

const tolerance = 64;
const resolution = 1;

const baseParams = {
  geometryType: "esriGeometryPoint",
  layers: "all:ch.swisstopo.swissnames3d",
  imageDisplay: `${tolerance * 2},${tolerance * 2},96`,
  tolerance: `${tolerance}`,
  returnGeometry: "false",
  geometryFormat: "geojson",
  sr: "2056",
};

export default async function swissNames(
  coordinates: number[],
  projection: Projection,
  retries = 3,
): Promise<string[]> {
  let attempts = 0;
  const swiss_coordinates = transform(coordinates, projection, "EPSG:2056");

  const halfDistance = resolution * tolerance;
  const extent = [
    swiss_coordinates[0] - halfDistance,
    swiss_coordinates[1] - halfDistance,
    swiss_coordinates[0] + halfDistance,
    swiss_coordinates[1] + halfDistance,
  ];
  const params = {
    ...baseParams,
    geometry: swiss_coordinates.join(","),
    mapExtent: extent.join(","),
  };
  const url = new URL(`${baseUrl}?${new URLSearchParams(params)}`);

  while (attempts++ < retries) {
    const response = await fetch(url);
    if (!response.ok) {
      continue;
    }
    const json = await response.json();

    // FIXME: exclude some objektart ?
    // FIXME: order by distance ?
    // FIXME: cache results ?
    // FIXME: return all results ?
    return json.results.map((result: { properties: { label: string } }) => result.properties.label);
  }
  return [];
}
